module.exports = __webpack_public_path__ + "static/media/sylviebook2.9c086635.png";